import React from "react";
import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentAccount = ({
  accountId = "account__123234",
  createdAt = "2021-01-01",
  paymentProviderIdentifierStripe = "acct_234234",
  username = "rd345fakeusername",
  rawData,
}) => {
  return (
    <ModelComponent
      modelId={accountId}
      colorBorderAccent="dark:border-color-dark-model-account border-color-model-account"
      rawData={rawData}
    >
      <RaindropInput
        label={"Created At"}
        value={createdAt}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />
      <RaindropInput
        label={"Stripe Account ID"}
        value={paymentProviderIdentifierStripe}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />
      <RaindropInput
        label={"Username"}
        value={username}
        onChange={() => {}}
        icon={null}
        isEditing={false}
        isShowLabel={true}
      />
    </ModelComponent>
  );
};

export default ModelComponentAccount;
